
import { RichText } from '@wordpress/block-editor';
import BlockContext from "../context/blockContext";
import { useContext } from "@wordpress/element";
import SectionItemContext from "../context/sectionItemContext";

function Awards() {
    const { updateField, scrollToSection, toggleReferencePanel } = useContext(BlockContext);
    const { item, index, itemIndex } = useContext(SectionItemContext);
  return (
    <ul
        className="cv-awards"
        onClick={() => scrollToSection("section8")}
        onClick={toggleReferencePanel}
    >
        <RichText
        tagName="li"
        className="award-item"
        value={item.name}
        onChange={(value) => updateField(index, "name", value, itemIndex)}
        />
    </ul>
  )
}

export default Awards
